import { useMemo } from "react";

import { PaymentOption } from "checkout-experience/components/payment-method/payment-option-provider";
import { getIsCobrandedCardNetworksEnabled } from "checkout-experience/utils/validators/card-network";
import { CheckoutSession } from "checkout-query-client/hooks/use-checkout-session";
import { usePaymentForm } from "checkout-query-client/hooks/use-form";

import {
  GetMerchantSettingsResponse_MerchantSettings,
  PlainMessage,
} from "frontend-client";

import { getIsFeatureEnabled } from "splitio-loader/src/utils/get-split-io-flag";

interface Params {
  checkoutSession: CheckoutSession | undefined;
  merchantSettings:
    | PlainMessage<GetMerchantSettingsResponse_MerchantSettings>
    | undefined;
  checkoutSessionToken: string | undefined;
  securityCodeForPay: boolean;
  target: string | undefined;
  paymentOption: PaymentOption | undefined;
}

export const useActiveFormFields = ({
  checkoutSession,
  merchantSettings,
  checkoutSessionToken,
  target,
  securityCodeForPay = false,
  paymentOption,
}: Params) => {
  const { formId = "", paymentType } = paymentOption ?? {};
  const { data: formConfig } = usePaymentForm({
    checkoutSession,
    merchantSettings,
    paymentType,
    formId,
    checkoutSessionToken,
  });

  return useMemo(() => {
    return Object.values(formConfig?.fields || {}).filter((field) => {
      if (
        field?.active &&
        field?.id === "securityCode" &&
        !securityCodeForPay
      ) {
        return false;
      }
      if (
        field?.active &&
        field?.id === "selectNetwork" &&
        !getIsFeatureEnabled(target, "co-branded-cards") &&
        !getIsCobrandedCardNetworksEnabled(merchantSettings)
        // && detectednetworks.length > 1 // TODO: CB
      ) {
        return false;
      }
      return field?.active;
    });
  }, [formConfig?.fields, securityCodeForPay]);
};
